import React from 'react'
import styled from 'styled-components'
import { WidgetProps } from '@rjsf/utils'

import { Button } from '../../../design-system/Button'
import { useExistsDefaultCloudServices, useSuggestEnrichedDescription } from './hooks'
import { EditorWidget } from '../../../design-system/FeedbotRjsfForm/components/widgets'

export const SuggestedIntentDescriptionWidget: React.FC<WidgetProps> = props => {
  const { formContext, ...restProps } = props
  const { prompt, utterance, description, llmChatService } = formContext.formData

  const existsDefaults = useExistsDefaultCloudServices('server')
  const { queryResult, suggestDescription } = useSuggestEnrichedDescription({
    onChangeTextOutput: props.onChange,
    ...{ prompt, utterance, description, llmChatService }
  })

  return (
    <Content>
      <EditorWidget {...restProps} isWrapTextEnabled />
      <Buttons>
        <StyledButton
          label="Suggest"
          loading={queryResult.isFetching || queryResult.isLoading}
          disabled={queryResult.isFetching || queryResult.isLoading}
          minMaxSizes={{ minWidth: 100, maxWidth: 100, maxHeight: 36 }}
          tooltip={existsDefaults ? undefined : 'Please choose LLM chat service.'}
          onClick={() => suggestDescription()}
        />
      </Buttons>
    </Content>
  )
}

const Content = styled.span`
  display: flex;
  flex-direction: row;
`

const Buttons = styled.span`
  display: flex;
  flex-direction: column;
`

const StyledButton = styled(Button)`
  padding: 0;
  min-width: 100px;
  margin-left: 15px;
`
